/* eslint-disable no-restricted-globals */
import React from 'react';

import { displayNumber } from '../../../helpers/numberHelpers';

export default class InputValue extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0,
            active: false
        };

        this.inputRef = React.createRef();
    }

    componentDidMount() {
        const { value } = this.props;
        this.changed(value);
    }

    componentWillReceiveProps(nextProps) {
        const { value } = this.state;
        if (nextProps.value !== value) {
            this.changed(nextProps.value);
        }
    }

    changed = v => {
        this.setState({ value: v });
    };

    onFocus = () => {
        this.setState({ active: true });
    };

    onBlur = () => {
        this.onComplete();
    };

    onKeyDown = e => {
        if (e.key === 'Enter' && this.inputRef && this.inputRef.current && this.inputRef.current.blur) {
            this.inputRef.current.blur();
        }
    };

    onComplete = () => {
        const { value } = this.state;
        const { min, max, onChange, value: propsValue } = this.props;
        this.setState({ active: false });

        if (value !== '' && !isNaN(value) && value >= min && value <= max) {
            onChange(value);
        } else {
            onChange(propsValue);
        }
    };

    getDescription = ({ description, value, precision }) => {
        let descriptionToDisplay;

        if (description == null) {
            descriptionToDisplay = displayNumber(value, precision || 0);
        } else if (typeof description === 'function') {
            descriptionToDisplay = description(displayNumber(value, precision || 0));
        } else {
            descriptionToDisplay = description;
        }

        return descriptionToDisplay;
    };

    render() {
        const { value, active } = this.state;
        const { min, max, description, disabled, precision, step } = this.props;

        const v = active ? value : this.getDescription({ description, value, precision });

        const classes = [];

        if (value < min || value > max) {
            classes.push('slider-value-input-error');
        }

        if (active) {
            classes.push('slider-value-input-active');
        }

        if (disabled) {
            classes.push('slider-value-input-disabled');
        }

        return (
            <div className="slider-value-input-wrapper">
                <input
                    className={`slider-value-input ${classes.join(' ')}`}
                    value={v}
                    onChange={e => this.changed(e.target.value)}
                    onKeyDown={this.onKeyDown}
                    onFocus={this.onFocus}
                    onBlur={this.onBlur}
                    placeholder={`${min} - ${max}`}
                    disabled={disabled}
                    ref={this.inputRef}
                />
            </div>
        );
    }
}
